import { render, staticRenderFns } from "./menuTipoVisualizacao.vue?vue&type=template&id=2b8ece03&scoped=true&"
import script from "./menuTipoVisualizacao.vue?vue&type=script&lang=js&"
export * from "./menuTipoVisualizacao.vue?vue&type=script&lang=js&"
import style0 from "./menuTipoVisualizacao.vue?vue&type=style&index=0&id=2b8ece03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ece03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VMenu})
